/**
 * Program Benefits 5009 — KUK "Your Career Roadmap".
 *
 * Career-path cards — an icon beside a role and what it involves — as a
 * two-column grid from 1080px and a horizontal rail below it, with a counsellor
 * CTA beside the heading (desktop) and at the foot (mobile). Ported from
 * kuk-campus-portal's `components/Degree/Roadmap.tsx`.
 *
 * Every field maps to a column that already exists on `program_benefits` — the
 * variant adds no schema of its own beyond widening `program_benefits.variant`.
 */

export const PROGRAM_BENEFITS_5009_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Career paths",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_title: "",
    meta_sub_title: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_BENEFITS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Your Career Roadmap",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Your Career Roadmap",
      required: false,
      defaultValue: "Your Career Roadmap",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "title_end_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      description: "The bar under the heading.",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_hover_background_color",
      label: "Card background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Card icon colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      description: "Applies to icon-key icons; uploaded images keep their own colours.",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "subtitle_color",
      label: "Card title colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#101112",
      required: false,
      defaultValue: "#101112",
    },
    {
      fieldName: "description_color",
      label: "Card description colour",
      value: "#4B4B4B",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#4B4B4B",
      required: false,
      defaultValue: "#4B4B4B",
    },
    {
      fieldName: "button_text",
      label: "CTA text (opens the lead form popup)",
      value: "Talk to our counsellor",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Talk to our counsellor",
      required: false,
      defaultValue: "Talk to our counsellor",
    },
    {
      fieldName: "button_icon_url",
      label: "CTA icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — upload, or type an icon name",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "CTA background colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      required: false,
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload an icon, or type an icon name",
      description: "Accepts an uploaded image URL OR a built-in icon name such as userSetting, breifcaseGroup.",
      defaultValue: "",
    },
    {
      header: "Role",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Executive Leadership",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 3,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [],
};
